<template>
  <div id="ks8123">
    <div id="k1">
      <span v-if="$store.state.iscn">
        <div>KS8123桌面式智能终端</div>
        <label>全视角10.1英寸IPS高清大屏，带来非凡的视觉与触觉体验</label>
        <img :src="require('@/assets/pic/ks8123/bg1icon.png')" />
      </span>
      <span v-else>
        <h5>KS8123</h5>
        <h5>Desktop Terminal</h5>
        <h5>10.1 inch IPS diaplay, excellent experience</h5>
      </span>
    </div>
    <div id="k2" v-if="$store.state.iscn">
      KS8123是一款高性能桌面式智能POS终端，配置磁条卡、接触IC卡、非接触IC卡、打印、扫码，金融密码键盘等功能模块，选配搭载人脸摄像头、指纹等生物识别模块，满足多种行业应用及线下收单业务需求。
    </div>
    <div id="k2_en" v-else>
      <img :src="require('@/assets/pic/ks8123/icongp.png')" />
    </div>
    <div id="k3">
      <div>{{$store.state.iscn?'卡折扫码 无所不能':'Biometric technology'}}</div>
      <label>{{$store.state.iscn?'集成存折、IC卡、NFC、扫码等支付方式，满足顾客的支付选择':'Strong security biometric system including facial recognition, fingerprint, iris, ID, etc.. '}}</label>
    </div>
    <div id="k4">
      <div>{{$store.state.iscn?'高清摄像  自由旋转':'Rotatable HD camera'}}</div>
      <label>{{$store.state.iscn?'3D结构光摄像头，高清防伪，自由旋转设计，精彩无限':'Perfect image capture.'}} </label>
    </div>
    <payscene :data="sdata"></payscene>
    <pdpp :data="ppdata"></pdpp>
    <pdspecs :data="spdata"></pdspecs>
  </div>
</template>

<script>
import payscene from '@/components/payscene'
import pdpp from '@/components/pdpp'
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    payscene,pdpp,pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  computed: {
    // lang () {
    //   return localStorage.lang
    // }
  },
  data () {
    var _this=this
    return {
      lang: localStorage.lang,
      sdata: {
        data: [
          {
            pic: require('@/assets/pic/ks8123/s1.png'),
            label: _this.$t('lang.phonepay')
          },
          {
            pic: require('@/assets/pic/ks8123/s2.png'),
            label: _this.$t('lang.facepay')
          },
          {
            pic: require('@/assets/pic/ks8123/s3.png'),
            label: _this.$t('lang.icpay')
          },
        ]
      },
      ppdata: {
        desc: _this.$t('lang.cafipci'),
        data: [
          {
            pic: require('@/assets/pic/ks8123/p1.png'),
            label: _this.$t('lang.camera')
          },
          {
            pic: require('@/assets/pic/ks8123/p2.png'),
            label: _this.$t('lang.figprint')
          },
          {
            pic: require('@/assets/pic/ks8123/p3.png'),
            label: _this.$t('lang.pcipswkb')
          }
        ]
      },
      spdata: {
        file: 'KS8123',
        data: [
          {label: _this.$t('lang.cpu'), desc: [_this.$t('lang.arm82gcpu'),_this.$t('lang.qc411gcpu')],pic: 'cpu.png'},
          {label: _this.$t('lang.memory'), desc: ['4GB RAM + 64GB ROM','2GB RAM + 16GB ROM'],pic: 'ram.png'},
          {label: _this.$t('lang.os'), desc: ['Android 9.0','Android 7.1'], pic: 'sys.png'},
          {label: _this.$t('lang.algor'), desc: [_this.$t('lang.sptalgs')], pic: 'safe.png'},
          {label: _this.$t('lang.display'), desc: [_this.$t('lang.inc10lcdblcg'),_this.$t('lang.scrmultch')], pic: 'disp.png'},
          {label: _this.$t('lang.cmropt'), desc: [_this.$t('lang.px130mcamer'),_this.$t('lang.s3dlfcpayrg')], pic: 'face.png'},
          {label: _this.$t('lang.idrgopt'), desc: [_this.$t('lang.sptid2'),_this.$t('lang.sptfgip')], pic: 'id.png'},
          {label: _this.$t('lang.scaner'), desc: [_this.$t('lang.spkofcode')], pic: 'scan.png'},
          {label: 'Ethernet', desc: ['10/100Mbps'], pic: 'ethr.png'},
          {label: _this.$t('lang.mobinet'), desc: [_this.$t('lang.gsmwcdmaevdtdfdd')], pic: 'mobi.png'},
          {label: _this.$t('lang.blueto'), desc: [_this.$t('lang.spblt40ble')], pic: 'blt.png'},
          {label: 'WIFI', desc: [_this.$t('lang.ieee8021abgnac'), _this.$t('lang.fr24p5ghz')], pic: 'wifi.png'},
          {label: _this.$t('lang.location'), desc: [_this.$t('lang.ingpsbdgln'),_this.$t('lang.sptlbsfunc'),_this.$t('lang.sptagps')], pic: 'lbs.png'},
          {label: _this.$t('lang.printer'), desc: [_this.$t('lang.bdin58prtr'),_this.$t('lang.spto40mmpp')], pic: 'prt.png'},
          {label: _this.$t('lang.keyboard'), desc: [_this.$t('lang.powerbtn1'), _this.$t('lang.butinpswkb'),_this.$t('lang.outerpswkb')], pic: 'keyb.png'},
          {label: _this.$t('lang.speaker'), desc: [_this.$t('lang.inspeaker2w')], pic: 'speaker.png'},
          {label: _this.$t('lang.port'), desc: [_this.$t('lang.usb2musb1rs232'), _this.$t('lang.rj45sim1hdm')], pic: 'port.png'},
          {label: _this.$t('lang.adapter'), desc: [_this.$t('lang.inputac100240'),_this.$t('lang.outputdc122a')], pic: 'char.png'},
          {label: _this.$t('lang.size'), desc: ['320mm×260mm×60mm'], pic: 'size.png'},
          {label: _this.$t('lang.suitenv'), desc: [_this.$t('lang.wktemp050')], pic: 'env.png'},
          {label: _this.$t('lang.keyboard'), desc: [_this.$t('lang.powerbtn1'), _this.$t('lang.butinpswkb'),_this.$t('lang.outerpswkb')], pic: 'keyb.png'},
        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#ks8123 {
  background: white;
  margin-top: -.93rem;
}
#k1 {
  height: 9rem;
  background-image: url('../../assets/pic/ks8123/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.46rem;
}
#k1 div {
  margin-top: 3.36rem;
  font-size: .6rem;
  font-weight: bold;
  color: #FFFFFF;
}
#k1 label {
  display: block;
  font-size: .24rem;
  font-weight: 400;
  color: #F4F4F4;
  margin-top: .2rem;
  margin-bottom: .39rem;
}
#k1 img {
  width: 4.9rem;
}
#k1 h5 {
  font-size: .6rem;
  font-weight: bold;
  color: #FFFFFF;
  margin: 0;
  padding: 0;
}
#k1 h5:nth-child(1) {
  margin-top: 3.24rem;
}
#k1 h5:nth-child(3) {
  font-size: .36rem;
  font-weight: 400;
  margin-top: .3rem;
  width: 3.54rem;
}
#k2 {
  background: #0279C4;
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  text-align: center;
  padding: .57rem 4.03rem .61rem 4.03rem;
  line-height: .48rem;
}
#k2_en {
  height: 1.78rem;
  text-align: center;
}
#k2_en img {
  margin: .66rem auto;
  /* height: .45rem; */
}
#k3 {
  height: 9rem;
  background-image: url('../../assets/pic/ks8123/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
  text-align: center;
}
#k3 div {
  margin: 1.75rem 0 .2rem 0;
  font-size: .6rem;
  font-weight: bold;
  color: #FFFFFF;
}
#k3 label {
  font-size: .24rem;
  font-weight: 400;
  color: #F4F4F4;
}

#k4 {
  height: 9rem;
  background-image: url('../../assets/pic/ks8123/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.47rem;
  color: white;
}
#k4 div {
  margin-top: 3.4rem;
  margin-bottom: .12rem;
  font-size: .6rem;
  font-weight: bold;
}
#k4 label {
  font-size: .24rem;
  font-weight: 400;
}

</style>
